import axios from "../../lib/axios"
import { GetProviderService } from "./types"

const getAllProvierFacilityBasedOnCalculator: GetProviderService = ({ params }) => {
  return axios.get("/api/v1/provider/getAllProvierFacilityBasedOnCalculator", { params })
}

const mainServices = { getAllProvierFacilityBasedOnCalculator }

export default mainServices
